import { useFormikContext } from "formik";

import { InputLabel, makeStyles, MenuItem } from "@material-ui/core";

import { useFormInputStyles } from "src/styles/forms";

import { useTenant } from "../LoggedInAdminProvider";
import FormikTextField from "./FormikTextField";
import { FormikSelect } from "./Select";

const useStyles = makeStyles(() => ({
  inlineForm: {
    display: "flex",
    flexDirection: "row",
    alignItems: "top",
    marginTop: "6px"
  },
  divider: {
    display: "inline-block",
    padding: "12px 6px"
  },
  timezoneSelect: {
    marginLeft: "12px",
    width: "300px"
  }
}));

function timeToHHMM(hhmmss: string): string {
  return hhmmss.substring(0, 5);
}

function timeFromHHMM(hhmm: string): string {
  if (hhmm) {
    return `${hhmm}:00`;
  }

  return "";
}

export default function FormikCallingHoursFields({
  startTimeFieldName = "startTime",
  endTimeFieldName = "endTime",
  timezoneFieldName = "timezone",
  disabled = false,
  label = null
}: {
  startTimeFieldName?: string;
  endTimeFieldName?: string;
  timezoneFieldName?: string;
  disabled?: boolean;
  label?: string | null;
}): JSX.Element {
  const tenant = useTenant()!;
  const formInputStyles = useFormInputStyles();
  const classes = useStyles();
  const { values, setFieldValue } = useFormikContext<any>();

  return (
    <div>
      {label && (
        <InputLabel shrink className={formInputStyles.inputLabel}>
          {label}
        </InputLabel>
      )}
      <div className={classes.inlineForm}>
        <FormikTextField
          type="time"
          name={startTimeFieldName}
          disabled={disabled}
          value={timeToHHMM(values[startTimeFieldName])}
          onChange={e => {
            const value = e.target.value || "";
            setFieldValue(startTimeFieldName, timeFromHHMM(value));
          }}
        />
        <span className={classes.divider}>-</span>
        <FormikTextField
          type="time"
          name={endTimeFieldName}
          disabled={disabled}
          value={timeToHHMM(values[endTimeFieldName])}
          onChange={e => {
            const value = e.target.value || "";
            setFieldValue(endTimeFieldName, timeFromHHMM(value));
          }}
        />
        <FormikSelect
          name={timezoneFieldName}
          disabled={disabled}
          className={classes.timezoneSelect}
        >
          {tenant.timezoneOptions.map(({ displayName, timezone }) => (
            <MenuItem key={timezone} value={timezone}>
              {displayName}
            </MenuItem>
          ))}
        </FormikSelect>
      </div>
    </div>
  );
}
